<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { SphInput } from '@/components/base/input';
import { useI18n } from '@/composables/i18n';
import { cn } from '@/utils/shadcn/lib/utils';

defineOptions({
    compatConfig: {
        MODE: 3,
    },
});

const props = defineProps<{
    pageCount: number
    disabled?: boolean
    class?: HTMLAttributes['class']
}>();

const page = defineModel<number>({ required: true });

const { i18n } = useI18n();

// An emptied field reports null — keeping the current page beats silently jumping to page 1.
function onInput(value: string | number | null): void {
    // NumberInput clamps to min/max but keeps decimals, and "2,5" is no page.
    if (typeof value === 'number' && Number.isFinite(value)) {
        page.value = Math.min(Math.max(Math.round(value), 1), props.pageCount);
    }
}
</script>

<template>
    <div :class="cn('flex items-center gap-2 px-2 whitespace-nowrap', props.class)">
        <span class="text-muted-foreground text-sm">{{ i18n.t('Seite') }}</span>
        <SphInput
            type="number"
            :model-value="page"
            :min="1"
            :max="props.pageCount"
            :disabled="props.disabled"
            :aria-label="i18n.t('Seite %{page} von %{pageCount}', { page, pageCount: props.pageCount })"
            class="w-14"
            size="sm"
            input-class="text-center px-2"
            @update:model-value="onInput"
        />
        <span class="text-muted-foreground text-sm">/ {{ props.pageCount }}</span>
    </div>
</template>
